import { stripTrailingSlash } from "@js/utils";

export const getAIInterviewUrl = ({ bidId }: { bidId: number }) => {
  return `${stripTrailingSlash(SETTINGS.BASE_URL)}/ai_interview/${bidId}`;
};
